export default __webpack_public_path__ + "static/media/dass-1.b49f297f.jpg";